
export default function Business() {
  const services = [
    {
      icon: 'ri-home-heart-line',
      title: '基礎料理コース',
      description: '包丁の持ち方から始める初心者向けコース。家庭料理の基本をしっかり学べます。',
      price: '¥8,800',
      duration: '月4回',
      image: 'https://public.readdy.ai/ai/img_res/4f507c5cfb3ba30875efc91ca235e8c2.jpg'
    },
    {
      icon: 'ri-restaurant-line',
      title: 'プロフェッショナルコース',
      description: '本格的な調理技術を習得。レストラン開業やプロの料理人を目指す方に最適です。',
      price: '¥15,800',
      duration: '月4回',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20chef%20teaching%20advanced%20cooking%20techniques%20in%20modern%20culinary%20school%20kitchen%20with%20stainless%20steel%20equipment%20and%20gourmet%20plating%20demonstration%20in%20bright%20clean%20professional%20cooking%20studio%20with%20white%20background&width=600&height=400&seq=business2&orientation=landscape'
    },
    {
      icon: 'ri-global-line',
      title: '世界の料理コース',
      description: 'イタリアン、フレンチ、中華など、世界各国の本格料理を学べる人気コースです。',
      price: '¥12,800',
      duration: '月4回',
      image: 'https://readdy.ai/api/search-image?query=International%20cuisine%20cooking%20class%20with%20variety%20of%20global%20dishes%20including%20pasta%20and%20Asian%20food%20displayed%20on%20elegant%20table%20in%20modern%20Japanese%20cooking%20studio%20with%20fresh%20ingredients%20and%20clean%20white%20minimalist%20background&width=600&height=400&seq=business3&orientation=landscape'
    },
    {
      icon: 'ri-cake-3-line',
      title: '製菓・製パンコース',
      description: 'ケーキやパン作りの技術を基礎から応用まで。お菓子作りの楽しさを体験できます。',
      price: '¥10,800',
      duration: '月4回',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20pastry%20baking%20class%20with%20beautiful%20cakes%20and%20fresh%20bread%20on%20wooden%20table%20in%20bright%20modern%20bakery%20studio%20with%20baking%20tools%20and%20ingredients%20displayed%20in%20clean%20white%20minimalist%20kitchen%20space&width=600&height=400&seq=business4&orientation=landscape'
    },
    {
      icon: 'ri-user-heart-line',
      title: 'キッズ料理教室',
      description: '子どもたちが楽しく料理を学べる特別プログラム。食育にも力を入れています。',
      price: '¥6,800',
      duration: '月4回',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20children%20enjoying%20cooking%20class%20with%20smiling%20kids%20making%20simple%20dishes%20under%20supervision%20in%20safe%20bright%20colorful%20kitchen%20studio%20with%20child%20friendly%20equipment%20and%20clean%20white%20background%20with%20natural%20lighting&width=600&height=400&seq=business5&orientation=landscape'
    },
    {
      icon: 'ri-computer-line',
      title: 'オンラインレッスン',
      description: '自宅から参加できるオンライン料理教室。全国どこからでも受講可能です。',
      price: '¥7,800',
      duration: '月4回',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20teaching%20online%20cooking%20class%20from%20home%20kitchen%20with%20laptop%20and%20camera%20setup%20showing%20cooking%20demonstration%20in%20modern%20bright%20kitchen%20with%20fresh%20ingredients%20and%20clean%20white%20minimalist%20background&width=600&height=400&seq=business6&orientation=landscape'
    }
  ];

  return (
    <section id="business" className="py-20 md:py-32 bg-gradient-to-br from-pink-50 to-orange-50">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-[1000px] mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">受講コースのご紹介</h2>
            <div className="w-20 h-1 bg-gradient-to-r from-pink-400 to-orange-400 mx-auto mb-6"></div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              多彩なコースをご用意し、あなたの目的やレベルに合わせた最適なレッスンを提供します
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer border-4 border-transparent hover:border-pink-200">
                <div className="p-6 flex justify-center">
                  <div className="w-64 h-64 rounded-full overflow-hidden relative">
                    <img 
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-top hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                </div>
                <div className="p-6 pt-0">
                  <div className="flex items-center justify-between mb-4">
                    <div className="w-14 h-14 flex items-center justify-center bg-gradient-to-br from-pink-400 to-orange-400 rounded-full shadow-lg">
                      <i className={`${service.icon} text-2xl text-white`}></i>
                    </div>
                    <div className="text-right">
                      <div className="text-2xl font-bold text-pink-400">
                        {service.price}／月
                      </div>
                      <div className="text-xs text-gray-500">税込</div>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed text-sm">{service.description}</p>
                  <button className="mt-6 w-full bg-gradient-to-r from-pink-400 to-orange-400 text-white font-bold py-3 rounded-full hover:shadow-lg hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer">
                    詳細を見る
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
